<script>
export default {
  name: 'StressForm',

  props: {
    pageData: {
      type: Object,
      required: true,
    },
    currentForm: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      tableHeaderFields: [
        { key: 'question_number', label: 'Número', class: 'text-center' },
        { key: 'spanish_question', label: 'Pregunta' },
        {
          key: 'always',
          label: 'Siempre',
          class: 'text-center',
        },
        {
          key: 'usualy',
          label: 'Casi siempre',
          class: 'text-center',
        },
        {
          key: 'sometimes',
          label: 'A veces',
          class: 'text-center',
        },
        // {
        //   key: 'rarely',
        //   label: 'Casi nunca',
        //   class: 'text-center',
        // },
        {
          key: 'never',
          label: 'Nunca',
          class: 'text-center',
        },
      ],
    }
  },

  computed: {
    selectorQuestion() {
      return this.pageData.questions_details.find(
        (q) => q.question_number === 0
      )
    },
    selectorQuestionOptions() {
      if (!this.selectorQuestion) return []
      return this.getOptions(this.selectorQuestion.questionoption_set_info)
    },
    // selectorQuestionValue() {
    //   if (!this.selectorQuestion || !this.selectorQuestionOptions.length) return
    //   const option = this.selectorQuestionOptions.find(
    //     (qo) =>
    //       qo.id === parseInt(this.currentForm[this.selectorQuestion.id], 10)
    //   )
    //   if (!option) return
    //   return option.value
    // },
    // showTable() {
    //   if (![15, 16, 26].includes(this.pageData.id)) return true
    //   if (!this.selectorQuestionValue) return false
    //   if (this.selectorQuestionValue !== 2) return true
    //   return false
    // },
  },

  watch: {
    // selectorQuestionValue(val) {
    //   this.$emit('selectorQuestionValue', val)
    // },
  },

  methods: {
    getQuestions(questionGroupId) {
      if (!questionGroupId) return
      return this.pageData.questions_details.filter(
        (q) => q.question_group_id === questionGroupId && q.question_number > 0
      )
    },

    getCheckboxValue(questionOptions, order) {
      if (!questionOptions) return 'not-found'
      const questionOption = questionOptions.find((qo) => qo.order === order)
      if (!questionOption) return 'not-found'
      // if (!questionOption) {
      //   return ''
      // }
      return questionOption.id
    },

    getOptions(options) {
      return options.map(({ id, text, value }) => ({ id, text, value }))
    },
  },
}
</script>

<template>
  <div>
    <div
      v-for="questionGroup in pageData.question_group_details"
      :key="questionGroup.id"
    >
      <h4>{{ questionGroup.title }}</h4>
      <p>{{ questionGroup.description }}</p>

      <div v-if="selectorQuestion">
        <!-- <pre>
 
        {{ getOptions(selectorQuestion.questionoption_set_info) }}
      </pre
        > -->

        <!-- <pre>
      {{ selectorQuestionValue }}
    </pre
        > -->
      </div>
      <div v-if="selectorQuestion">
        <b-form-group :label="selectorQuestion.spanish_question">
          <b-form-select
            v-model="currentForm[selectorQuestion.id]"
            :options="selectorQuestionOptions"
            value-field="id"
            text-field="text"
          />
        </b-form-group>
      </div>
      <!-- <div v-if="showTable"> -->
      <div >
        <b-table
          outlined
          responsive="md"
          :fields="tableHeaderFields"
          :items="getQuestions(questionGroup.id)"
        >
          <template v-slot:cell(always)="row">
            <div>
              <div>

<!-- <pre class="text-left">

              {{row.item.questionoption_set_info}}
</pre> -->
              </div>
              <b-form-radio
                v-model="currentForm[row.item.id]"
                size="lg"
                :value="getCheckboxValue(row.item.questionoption_set_info, 1)"
              />
            </div>
          </template>

          <template v-slot:cell(usualy)="row">
            <div>
              <b-form-radio
                v-model="currentForm[row.item.id]"
                size="lg"
                :value="getCheckboxValue(row.item.questionoption_set_info, 2)"
              />
            </div>
          </template>

          <template v-slot:cell(sometimes)="row">
            <div>
              <b-form-radio
                v-model="currentForm[row.item.id]"
                size="lg"
                :value="getCheckboxValue(row.item.questionoption_set_info, 3)"
              />
            </div>
          </template>

          <!-- <template v-slot:cell(rarely)="row">
            <div>
              <b-form-radio
                v-model="currentForm[row.item.id]"
                size="lg"
                :value="getCheckboxValue(row.item.questionoption_set_info, 4)"
              />
            </div>
          </template> -->

          <template v-slot:cell(never)="row">
            <div>
              <b-form-radio
                v-model="currentForm[row.item.id]"
                size="lg"
                :value="getCheckboxValue(row.item.questionoption_set_info, 4)"
              />
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <!-- <pre>
          {{ pageData }}
    </pre> -->
  </div>
</template>